// fader
fadeInPage();

function fadeInPage() {
      if (!window.AnimationEvent) { return; }
      var fader = document.getElementById('fader');
  fader.classList.add('fade-out');
}

document.addEventListener('DOMContentLoaded', function() {
    if (!window.AnimationEvent) { return; }
    var anchors = document.getElementsByTagName('a');

for (var idx=0; idx<anchors.length; idx+=1) {
  if (anchors[idx].hostname !== window.location.hostname ||
           anchors[idx].pathname === window.location.pathname || anchors[idx].target === "_blank")   {
           continue;
       }
       anchors[idx].addEventListener('click', function(event) {
          var fader = document.getElementById('fader'),
              anchor = event.currentTarget;

          var listener = function() {
              window.location = anchor.href;
              fader.removeEventListener('animationend', listener);
          };
          fader.addEventListener('animationend', listener);

          event.preventDefault();
          fader.classList.add('fade-in');
       });
   }
});
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) {
    return;
  }
  var fader = document.getElementById('fader');
  fader.classList.remove('fade-in');
});

$(document).ready(function() {

    // mini-cart
    $('.cart-trigger').on("click", function() {

      // if($(window).width() >= 960 && !$('html').hasClass("tablet")) {
      $('#mini-cart').fadeIn(300);

      return false

    // }
    })

    $('.cart-close').on("click", function() {
      $('#mini-cart').fadeOut(300);
    })

    onVariantRadioChange = function(event) {
      let
        $radio = $(this),
        $form = $radio.closest('form'),
        max = $radio.attr('data-inventory-quantity'),
        $addToCartButton = $form.find('#add-to-cart');


    },
    onAddToCart = function(event) {
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: onCartUpdated,
        error: onError
      });
    },
    onLineRemoved = function(event) {
      event.preventDefault();

      let
        $removeLink = $(this),
        removeQuery = $removeLink.attr('href').split('change?')[1];
      $.post('/cart/change.js', removeQuery, onCartUpdated, 'json');
    },
    onCartUpdated = function() {
      $.ajax({
        type: 'GET',
        url: '/cart',
        context: document.body,
        success: function(context) {
          let
            $dataCartContents = $(context).find('.js-cart-page-contents'),
            dataCartHtml = $dataCartContents.html(),
            dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
            dataCartItemTotal = $dataCartContents.attr('data-cart-item-total'),
            $miniCartContents = $('.js-mini-cart-contents'),
            $cartItemCount = $('.js-cart-item-count');
            $cartItemTotal = $('.js-cart-item-total');

          $cartItemCount.text(dataCartItemCount);
          $cartItemTotal.text(dataCartItemTotal);
          $miniCartContents.html(dataCartHtml);

          if (parseInt(dataCartItemCount) > 0) {
            openCart();

            $('.add-button').val("PRODUCT ADDED TO BAG");

            setTimeout( function(){
              $('.add-button').val("ADD TO BAG");
            }  ,2000 );

            $('.cart-cta').html('<a class="mini-cart-button ttu green-color br-pill tc ph4 pv1" href="/cart">Process order</a>')
            $('.mini-cart-count_wrapper').html('<p class="added-notification"><span class="js-cart-item-count">' + dataCartItemCount + '</span> PRODUCTS ADDED</p>')

          }
          else {

            closeCart();
          }
        }
      });
    },
    onError = function(XMLHttpRequest, textStatus) {
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + ' - ' + data.message + ': ' + data.description);
    },
    openCart = function() {

      // if($(window).width() >= 960 && !$('html').hasClass("tablet")) {

        $('html, body').addClass('mini-cart-open');
        $('#mini-cart').fadeIn(300);
        setTimeout(function() {
            $('#mini-cart').fadeOut(300);
            $('html, body').removeClass('mini-cart-open');
        }, 6000);

      // } else {

      // };

    },
    closeCart = function() {
      $('html, body').removeClass('mini-cart-open');
      $('#mini-cart').fadeOut(300);
    },
    onCartButtonClick = function(event) {
      event.preventDefault();

      let isCartOpen = $('html').hasClass('mini-cart-open');

      if (!isCartOpen) {
        openCart();
      }
      else {
        closeCart();
      }
    };

  $(document).on('change', '.js-variant-radio', onVariantRadioChange);
  $(document).on('submit', '#add-item-form', onAddToCart);
  $(document).on('click', '#mini-cart .js-remove-line', onLineRemoved);
  $(document).on('click', '.js-cart-link', onCartButtonClick);


});


// shop hover
$(function() {
  $('.plp-item').on("mouseenter", function() {
    var id = $(this).attr("id");
    $('.shop-thumb#' + id +'').removeClass("dn").addClass("db");
  });
  $('.plp-item').on("mouseleave", function() {
    $('.shop-thumb').removeClass("db").addClass("dn");
  })
})


// input number
function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 1) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(1);
  }
}

$('.input-quantity').on('click', '.button-plus', function(e) {
  incrementValue(e);
});

$('.input-quantity').on('click', '.button-minus', function(e) {
  decrementValue(e);
});


// hash menu
// $('.menu-mobile a.hash').click(function(e){
//     var url=$(this).attr('href');
//
//     window.location.href=url;// ## change url with hash
//     location.reload();       // ## reload page
//
//     e.preventDefault();      // ## prevent default click action
// })

  // product slider
  const swiper = new Swiper('.slider-main-desk', {
    init: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    initialSlide: 0,
    updateOnWindowResize: true,
    observeParents: true,
  
    // preloadImages: false,
    // lazy: true,
    // lazyPreloadPrevNext: 2,
    allowTouchMove: true,
    // centeredSlides: true,
    loop: true,
    mousewheel: {
      invert: true,
    },
    effect: "fade",
    speed: 1,
    fadeEffect: {
      crossFade: true
    },
    // navigation: {
    // nextEl: '.slider-main .swiper-slide',
    // },

    breakpoints: {
      960: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        speed: 0,
       
      }
    },

    thumbs: {
      autoScrollOffset: 0,
      swiper: {
        el: '.slider-thumbs',
        initialSlide: 0,
        allowTouchMove: false,
        observeParents: true,
        spaceBetween: 0,
        threshold: 2,
        slidesPerView: 0,
        direction: "horizontal",
        speed: 0,
      }
    },
  });


  const swipermob = new Swiper('.slider-main-mob', {
    init: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    initialSlide: 0,
    updateOnWindowResize: true,
    observeParents: true,
  
    // preloadImages: false,
    // lazy: true,
    // lazyPreloadPrevNext: 2,
    allowTouchMove: true,
    // centeredSlides: true,
    loop: true,
    mousewheel: {
      invert: true,
    },
    speed: 300,

    // navigation: {
    // nextEl: '.slider-main .swiper-slide',
    // },

    breakpoints: {
      960: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        speed: 0
      }
    }
  });

  $(function() {
    setTimeout(function() {
      if (window.innerWidth < 960) {
      swipermob.init();
      } else {
        swiper.init();
      }
    }, 100);
  
  })
  
  var sliderThumbsContainer = document.querySelector('.slider-thumbs')
  if (sliderThumbsContainer){
  var sliderThumbs = sliderThumbsContainer.querySelectorAll('.swiper-slide')
  $('.swiper-slide').on('mouseenter',function(){
    var indexToMove = $(this).attr('data-slide');
   
    swiper.slideTo(indexToMove,1000,false);
  });}
  



// horizotnal scroll

function scrollRight() {
  if($(window).width() >= 480 && !$('html').hasClass("tablet") ) {

  $(".about-scroll, .cart-items, .blog-scroll").mousewheel(function(event, delta) {
     this.scrollLeft -= (delta * 1);
     event.preventDefault();
  });

}
}

$(function() {
  scrollRight();
  $(window).on('resize', function(){
    scrollRight();
  });
})

// menu mobile
$('.menu-trigger').on("click", function() {
  var $menu = $('.menu-mobile');
  var isCurrentlyVisible = $menu.is(':visible');
  
  $menu.fadeToggle(300, function() {
    // Update all menu triggers after animation completes
    var isMenuVisible = $menu.is(':visible');
    $('.menu-trigger').text(isMenuVisible ? 'Close' : 'Menu');
  });
  
  $('body').toggleClass("locked");
  $('body').toggleClass("menu-open");
  
  // Close go-cart when opening mobile menu
  if (window.goCart) {
    window.goCart.closeMiniCart();
    window.goCart.closeCartOverlay();
  }
})

// newsletter popup
$(document).ready(function() {
	$('.newsletter-close').click(function(){
        $('.newsletter-popup').fadeOut(300);

        if (!$('.newsletter-popup').is()) {
			      // Add the cookie. It will remain for a month
            Cookies.set('popup', 1, { expires: 30, path: '/' })
        	}
		return false;
    });

	// If the cookie is true, don't show the cookie bar
	if (!Cookies.get('popup') == 1) {
    setTimeout(function() {
     $('.newsletter-popup').fadeIn(300)
    }, 6000)
	}
});

$(document).ready(function() {
	$('.subscribe-trigger').on("click", function() {
    $('.newsletter-popup').fadeIn(300);
  })
});


// android header
// if (navigator.userAgent.match(/Android/)) {
//    $('.navigation, .navigation-mobile, .logo, .player, .home-box-1, .home-box-2, .home-box-3').addClass("android-text");
// }

// Product gallery mobile Flickity slider with watchCSS
$(document).ready(function() {
  const productGallerySlider = $('.product-gallery').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    adaptiveHeight: true,
    wrapAround: false,
    autoPlay: false,
    draggable: true,
    selectedAttraction: 0.025,
    friction: 0.28,
    watchCSS: true
  });
});

// Scroll lock for gocart mini cart
$(document).ready(function() {
  // Watch for when gocart mini cart opens/closes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const miniCart = document.querySelector('.go-cart__mini-cart');
        if (miniCart) {
          if (miniCart.classList.contains('is-open')) {
            $('html, body').addClass('mini-cart-open');
          } else {
            $('html, body').removeClass('mini-cart-open');
          }
        }
      }
    });
  });
  
  // Start observing the mini cart element
  const miniCart = document.querySelector('.go-cart__mini-cart');
  if (miniCart) {
    observer.observe(miniCart, { attributes: true });
  }
});

(() => {
  const bar = document.querySelector('aside.adaptive-pricing-announcement-bar');
  if (!bar) return;

  let ticking = false;
  const update = () => {
    bar.classList.toggle('is-hidden', window.scrollY >= window.innerHeight);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update(); // handles page loads that start partway down
})();